import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";

function TickerMasterSpecialExamIntermediate() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [tickerText, setTickerText] = useState("");
    const [class11ticker, setClass11Ticker] = useState("");
    const [class12ticker, setClass12Ticker] = useState("");
    const [tickerId, setTickerId] = useState(null);
    const token = sessionStorage.getItem("intermediateAdminToken");

    useEffect(() => {
        if (!token) {
            navigate("/intermediate-admin");
        } else {
            fetchTicker();
        }
    }, []);

    const fetchTicker = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `${config.API_BASE_URL}/CSExamFetchAdminTickerMasterDataIntermediate`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                },
            );

            const data = await response.json();
            if (response.ok && data.status === 200) {
                setTickerText(data.data.tickerMaster_list[0].title);
                setClass12Ticker(data.data.tickerMaster_list[0]?.cL_12_LOGIN_TITLE);
                setClass11Ticker(data.data.tickerMaster_list[0]?.cL_11_LOGIN_TITLE);
                setTickerId(data.data.tickerMaster_list[0].id);
            }
        } catch (error) {
            console.error("Error fetching ticker:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        /* if (tickerText.trim() === "") {
                Swal.fire("Warning", "Ticker text cannot be empty!", "warning");
                return;
            } */
        setLoading(true);
        try {
            const response = await fetch(
                `${config.API_BASE_URL}/CSExamAdminInsertUpdateTickerMasterIntermediate`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        id: tickerId ? tickerId : null,
                        title: tickerText || "",
                        UPDATE_BY: sessionStorage.getItem("schoolCode") || "",
                        cL_11_LOGIN_TITLE: class11ticker || "",
                        cL_12_LOGIN_TITLE: class12ticker || "",
                    }),
                },
            );

            const data = await response.json();

            if (response.ok && data.status === 200) {
                Swal.fire("Success", "Ticker updated successfully!", "success");
                fetchTicker();
            } else {
                Swal.fire("Error", data.message || "Failed to update ticker.", "error");
            }
        } catch (error) {
            console.error("Error saving ticker:", error);
            Swal.fire("Error", "An unexpected error occurred.", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-scroller">
            {loading && (
                <div className="custom-loader-container">
                    <div className="custom-loader"></div>
                </div>
            )}
            <Navbar />
            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <section className="content-header">
                                    <h1>
                                        <i className="fa fa-university" />
                                        &nbsp;Ticker Master (Special Exam)
                                    </h1>
                                    <ol className="breadcrumb">
                                        <li>
                                            <a
                                                onClick={() =>
                                                    navigate("/intermediate-admin-dashboard")
                                                }
                                                style={{ cursor: "pointer" }}
                                            >
                                                <i
                                                    className="fa fa-tachometer"
                                                    style={{ marginRight: "5px" }}
                                                ></i>{" "}
                                                Home
                                            </a>
                                        </li>
                                        <li className="active">Intermediate Admin Ticker Master (Special Exam)</li>
                                    </ol>
                                </section>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 mb-4 stretch-card">
                                <div className="card">
                                    <div className="card-header bg-green">
                                        <h4 className="mb-0 p-2">Ticker Master</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            {/* <div className="col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="fw-bold">
                                                        Ticker Master :

                                                    </label>
                                                    <textarea
                                                        className="form-control form-control-sm"
                                                        rows="7"
                                                        required
                                                        value={tickerText}
                                                        onChange={(e) => setTickerText(e.target.value)}
                                                    ></textarea>
                                                </div>
                                            </div> */}
                                            <div className="col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="fw-bold">
                                                        Class 11 Login Page Ticker :
                                                        {/* &nbsp;<span className="text-danger">*</span> */}
                                                    </label>
                                                    <textarea
                                                        className="form-control form-control-sm"
                                                        rows="7"
                                                        required
                                                        value={class11ticker}
                                                        onChange={(e) => setClass11Ticker(e.target.value)}
                                                    ></textarea>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="fw-bold">
                                                        Class 12 Login Page Ticker :
                                                        {/* &nbsp;<span className="text-danger">*</span> */}
                                                    </label>
                                                    <textarea
                                                        className="form-control form-control-sm"
                                                        rows="7"
                                                        required
                                                        value={class12ticker}
                                                        onChange={(e) => setClass12Ticker(e.target.value)}
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <button
                                            className="btn btn-success me-2"
                                            style={{ float: "right" }}
                                            onClick={handleSave}
                                            disabled={loading}
                                        >
                                            <i className="fa fa-save" />{" "}
                                            {loading ? "Saving..." : "Save"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
}

export default TickerMasterSpecialExamIntermediate;
